"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loginVerifyEcho = void 0;

var ImmutableAPI = _interopRequireWildcard(require("crm_data/api/ImmutableAPI"));

var _Raven = _interopRequireDefault(require("Raven"));

var _SettingsSetup = require("crm_internal/setup/SettingsSetup");

/**
 * Hits the `login-verify/echo` endpoint to refresh auth status and scoeps.
 *
 * This method is a simple healthcheck from the auth backend that lets us
 * check the user's current auth status, as well as get new/changed scopes from
 * the backend. This ensures that even if a user's permissions change during a
 * session or the user gets logged out, they won't retain access to specific
 * features or, in the worst case, the entire app, when they're not authorized.
 *
 * While it can be called at any time, it's intended to be called on a polling
 * interval to keep the current user's auth status up to date.
 *
 * @example
 * setInterval(() => {
 *   loginVerifyEcho();
 * }, I18n.moment.duration(10, 'minutes').valueOf())
 */
var loginVerifyEcho = function loginVerifyEcho() {
  return ImmutableAPI.get('/login-verify/echo').then(function (response) {
    (0, _SettingsSetup.setScopes)(response.get('scopes').toJS());
  }).catch(function (err) {
    return _Raven.default.captureException(err);
  }).done();
};

exports.loginVerifyEcho = loginVerifyEcho;